import { createSelector, createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const organizacijaAdapter = createEntityAdapter({})

const initialState = organizacijaAdapter.getInitialState()

export const organizacijaApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getOrganizacija: builder.query({
            query: () => ({
                url: '/organizacija',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedOrganizacija = responseData.map(organizacija => {
                    organizacija.id = organizacija._id
                    return organizacija
                });
                return organizacijaAdapter.setAll(initialState, loadedOrganizacija)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'Organizacija', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'Organizacija', id }))
                    ]
                } else return [{ type: 'Organizacija', id: 'LIST' }]
            }
        }),
        getOrganizacijeSaPozicijama: builder.query({
            query: (id) => ({
                url: `/organizacija/pozicija/${id}`,
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError;
                },
            }),
            transformResponse: (responseData) => {
                const loadedData = responseData.map(item => {
                    item.id = item._id;
                    return item;
                });
                return organizacijaAdapter.setAll(initialState, loadedData);
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'Organizacija', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'Organizacija', id })),
                    ];
                } else return [{ type: 'Organizacija', id: 'LIST' }];
            },
        }),
        getOrganizacijaNames: builder.query({
            query: () => ({
                url: '/organizacija/names',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
        }),
        addNewOrganizacija: builder.mutation({
            query: initialUserData => ({
                url: '/organizacija',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'Organizacija', id: "LIST" }
            ]
        }),
        addNewPozicijuOrganizaciji: builder.mutation({
            query: initialUserData => ({
                url: '/organizacija/pozicija',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'Organizacija', id: "LIST" }
            ]
        }),
        updateOrganizacija: builder.mutation({
            query: initialUserData => ({
                url: '/organizacija',
                method: 'PATCH',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Organizacija', id: arg.id }
            ]
        }),
        updatePozicijaUOrganizaciji: builder.mutation({
            query: initialUserData => ({
                url: '/organizacija/pozicija',
                method: 'PATCH',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Organizacija', id: arg.id }
            ]
        }),
        updatePozicijaZaposlenogUOrganizaciji: builder.mutation({
            query: initialUserData => ({
                url: `/organizacija/pozicija/zaposleni`,
                method: 'PATCH',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Organizacija', id: arg.id }
            ]
        }),
        //
        deleteOrganizacija: builder.mutation({
            query: ({ id }) => ({
                url: `/organizacija`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Organizacija', id: arg.id }
            ]
        }),
        //id = pozicija zaposlenog , name = organizacija ime
        deletePozicijaUOrganizaciji: builder.mutation({
            query: ({ id, name }) => ({
                url: `/organizacija/pozicija`,
                method: 'DELETE',
                body: { id, name }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Organizacija', id: arg.id }
            ]
        }),
        //id = organizacije, idZap je pozicija zaposlenog u toj organizaciji 
        deletePozicijaZaposlenogUOrganizaciji: builder.mutation({
            query: ({ idOrg, idZap }) => ({
                url: `/organizacija/pozicija/zaposleni`,
                method: 'DELETE',
                body: { idOrg, idZap }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Organizacija', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetOrganizacijaQuery,
    useGetOrganizacijeSaPozicijamaQuery,
    useGetOrganizacijaNamesQuery,
    useAddNewOrganizacijaMutation,
    useAddNewPozicijuOrganizacijiMutation,
    useUpdateOrganizacijaMutation,
    useUpdatePozicijaUOrganizacijiMutation,
    useUpdatePozicijaZaposlenogUOrganizacijiMutation,
    useDeleteOrganizacijaMutation,
    useDeletePozicijaUOrganizacijiMutation,
    useDeletePozicijaZaposlenogUOrganizacijiMutation
} = organizacijaApiSlice

// // returns the query result object
// export const selectUsersResult = organizacijaApiSlice.endpoints.getUsers.select()

// // creates memoized selector
// const selectUsersData = createSelector(
//     selectUsersResult,
//     usersResult => usersResult.data // normalized state object with ids & entities
// )

// //getSelectors creates these selectors and we rename them with aliases using destructuring
// export const {
//     selectAll: selectAllUsers,
//     selectById: selectUserById,
//     selectIds: selectUserIds
//     // Pass in a selector that returns the users slice of state
// } = organizacijaAdapter.getSelectors(state => selectUsersData(state) ?? initialState)